export default function() {
    return {
        colorLoading: '#303C54',
        sizeLoading: '20px'
    }
}
